<template>
  <div class="wrapper max-width">
    <div class="content white-background">
      <div class="header-icon">
        <img :src="logoIcon" />
      </div>
      <div class="login-header">
        {{ $t('loginHeaderText') }}
      </div>
      <div class="login-input">
        <p class="title">
          {{ $t('loginName') }}
        </p>
        <div class="content">
          <input
            class="content-input" type="text" :value="loginName" :placeholder="$t('loginNamePlaceholder')"
            @input="onChange($event, 'loginName')" />
        </div>
      </div>
      <div class="login-input">
        <p class="title">
          {{ $t('password') }}
        </p>
        <div class="content">
          <input
            class="content-input" type="password" :value="password" :placeholder="$t('passwordPlaceholder')"
            @input="onChange($event, 'password')" />
        </div>
      </div>
      <div class="next-button" :class="{ static: layoutSwitch }">
        <div class="next-button-text" @click="clientLogin">
          {{ $t('login') }}
        </div>
        <div class="close-button-text" v-if="loginFrom === 'chatbot'" @click="chatbotAuthenticatationResult('','')">
          {{ $t('closeWindow') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DialogBox
} from '@/components'
import {
  Logo_Color
} from '@/images/index'
import utils from '@/utils/utils'
import serviceConfig from '@/service/config'
import {
  geth5Token
} from '@/service/web'

const { getUrlQuery, getUrl, getCookie, deleteCookie } = utils

export default {
  name: 'Login',
  components: {

  },
  data () {
    return {
      isLoading: true,
      isNetError: false,
      loginName: '',
      password: '',
      rndkey: '',
      originDocHeight: document.documentElement.clientHeight || document.body.clientHeight,
      currentDocHeight: document.documentElement.clientHeight || document.body.clientHeight,
      layoutSwitch: false,
      lang: '',
      logoIcon: '',
      loginFrom: ''
    }
  },
  watch: {
    currentDocHeight: function setLayoutSwitch () {
      this.layoutSwitch = this.originDocHeight > this.currentDocHeight
    }
  },
  created () {
    this.initData()
  },
  mounted () {
    const chatbotBeforeUnloadHandler = (event) => {
      // event.preventDefault()
      // event.returnValue = true

      this.chatbotAuthenticatationResult('', '')
    }

    if (this.loginFrom === 'chatbot') {
      // var isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)
      // if (isOnIOS) {
      // document.addEventListener('visibilitychange', function() {
      //   // fires when user switches tabs, apps, goes to homescreen, etc.
      //     if (document.visibilityState == 'hidden') {
      //       this.chatbotAuthenticatationResult('','')
      //     }
      // })
      // window.addEventListener('blur', chatbotBeforeUnloadHandler)
      // } else {
      window.addEventListener('beforeunload', chatbotBeforeUnloadHandler)
      // window.onbeforeunload = chatbotBeforeUnloadHandler
      // }
    }
  },
  methods: {
    initData () {
      // console.log('cookie before', document.cookie)
      deleteCookie(['session', 'trade_session', 'uin', 'mmaclientid'])
      // console.log('cookie after', document.cookie)
      this.getQuery()
      this.logoIcon = Logo_Color
    },
    getQuery () {
      const params = getUrlQuery()
      this.lang = params.lang || 'en-US'
      this.loginFrom = params.loginfrom || ''
    },
    networkErr () {
      DialogBox({
        content: this.$t('netErrorToast'),
        confirmText: this.$t('confirm'),
        showCancel: false
      })
    },
    async clientLogin () {
      const axios = require('axios')
      const requestData = {
        loginname: this.loginName,
        value: this.password,
        logintype: 2,
        auth: this.getLoginAuth(),
        isweblogin: 'Y'
      }
      const config = {
        headers: {
          'Accept-Language': 'zh-CN',
          'x-product': 'connect||version=1.13.0',
          // eslint-disable-next-line
          'x-device': 'iOS||osver=13.3.1||romver=||model=iPhone||identity=01866B64-8620-4305-A5D1-C7D80B96AB66||lang=zh-Hans-CN||network=2||channel=201010101309||screen=1080x1920',
          'x-host': serviceConfig.webDomain
        },
        withCredentials: true
      }
      const mainHost = serviceConfig.domain
      const url = `${mainHost}/v1/mma/connect/sso/login`
      try {
        const loginResult = await axios.post(url, requestData, config)
        if (loginResult && loginResult.data && loginResult.data.code === 0) {
          const myClientId = loginResult.data.data.mmaclientid
          const MyUin = loginResult.data.data.uin

          const businessUrl = myClientId
            ? `${mainHost}/v1/mma/connect/sso/clients/${myClientId}/login`
            : `${mainHost}/v1/mma/connect/sso/users/${MyUin}/business/login`
          const businessResult = await axios.post(businessUrl, {
            passwdtype: 1,
            auth: '',
            isweblogin: true
          }, config)
          if (businessResult && businessResult.data && businessResult.data.code === 0) {
            // console.log('businessResult', businessResult)
            localStorage.removeItem('cntloginData')
            loginResult.data.data.rndkey = this.rndkey
            localStorage.setItem('cntloginData', JSON.stringify(loginResult.data.data))

            // console.log('trade_session cookie', getCookie('trade_session'))
            const trade_session = getCookie('trade_session')
            if (trade_session === '' || trade_session === undefined || trade_session === 'undefined') {
              DialogBox({
                content: this.$t('netErrorToast'),
                confirmText: this.$t('confirm'),
                showCancel: false
              })
            } else {
              if (this.loginFrom == 'chatbot') {
                this.authenticateChatbot(myClientId)
              } else {
                const url = getUrl('terms-and-conditions', {
                  lang: this.lang
                })
                window.location.href = url
              }
            }
          } else {
            DialogBox({
              content: this.$t('loginError'),
              confirmText: this.$t('confirm'),
              showCancel: false
            })
          }
        } else {
          DialogBox({
            content: this.$t('loginError'),
            confirmText: this.$t('confirm'),
            showCancel: false
          })
          // console.log('login failed,', loginResult)
        }
      } catch (err) {
        console.error(err)
      }
    },
    getLoginAuth (version = 1) {
      const versionData = this.getByteString(version, 4)
      const theTime = new Date().getTime()
      const timeData = this.getByteString(theTime, 8)
      const rndKeyData = this.getRndkey(32)
      this.rndkey = this.bytesToHex(rndKeyData)
      const resultByte = versionData + timeData + rndKeyData
      const resultHex = this.bytesToHex(resultByte)
      return resultHex
    },
    getByteString (value, byteNum) {
      const valueString = value.toString(2)
      let defaultString = ''
      const needNum = byteNum * 8 - valueString.length
      for (let i = 0; i < needNum; i++) {
        defaultString += '0'
      }
      return defaultString + valueString
    },
    getRndkey (length) {
      var arr = [0, 1]
      var str = ''
      for (var i = 0; i < length * 8; i++) {
        const temp = Math.random() * 10 > 5 ? arr[1] : arr[0]
        str += temp
      }
      return str
    },
    bytesToHex (byteStr) {
      var str = ''
      for (var i = 0; i < byteStr.length; i = i + 4) {
        const byte = byteStr.slice(i, i + 4)
        const hex = parseInt(byte, 2).toString(16)
        str += hex
      }
      return str
    },
    onChange (e, id) {
      switch (id) {
        case 'loginName':
          this.loginName = e.target.value
          break
        case 'password':
          this.password = e.target.value
          break
      }
    },
    async authenticateChatbot (mmaclientid) {
      const h5TokenResult = await geth5Token(mmaclientid)
      const config = {
        headers: {
          // 'Accept-Language': 'zh-CN',
          // 'x-product': 'connect||version=1.13.0',
          // // eslint-disable-next-line
          // 'x-device': 'iOS||osver=13.3.1||romver=||model=iPhone||identity=01866B64-8620-4305-A5D1-C7D80B96AB66||lang=zh-Hans-CN||network=2||channel=201010101309||screen=1080x1920',
          // 'x-host': serviceConfig.webDomain
          'Access-Control-Allow-Origin': serviceConfig.cust360Domain,
          'x-functions-key': serviceConfig.cust360ApiKey
        },
        withCredentials: true
      }
      const cust360Host = serviceConfig.cust360Domain
      const url = `${cust360Host}/v1/get_internal_access_token`

      const req = {
        clientid: mmaclientid,
        token: h5TokenResult.token
      }

      const axios = require('axios')

      const authResult = await axios.post(url, req, config)
      if (authResult && authResult.data && authResult.data.code == 0) {
        console.log('Completed Authentication')
        this.chatbotAuthenticatationResult(mmaclientid, authResult.data.data.access_token)
      }
    },
    chatbotAuthenticatationResult (customerId, sessionKey) {
      var o = {
        command: 'authentication',
        info: {
          customerId,
          sessionKey
        }
      }
      window.opener.postMessage(o, '*')
      window.close()
    }
  }
}
</script>
  <style lang="scss">
  @import './index.scss';
  </style>
